import React, { useState, useEffect } from "react";
// import {FilePicker} from
import {
    Breadcrumbs,
    DatePickerInput,
    Button,
    ContentBlock,
    Dropdown,
    FormFooter,
    Switch,
    Tooltip,
    StatusDot,
    FormGroup,
    Head,
    Select,
    Card,
    Checkbox,
    Icon,
    Input,
    Pill,
    FormCaption
} from 'xsolla-uikit';

import { Link } from "react-router-dom";
import { blankKey } from "../BlankKey";
import PAContentBlock from "../PAContentBlock";
import PAh2 from "../PAh2";

import PAmodal from "../PApop";

import CardNew from "../PAcardNew";

import {
  ButtonSquare,
  PAinfoCollapsible,
  CssClick,
  CssTh,
  CssLineHover,
  CssSelectStatus,
  CssThTd,
  CssThFilt0,
  CssCounter
} from "../uikit2";

import styled, { css } from "styled-components";

import {
  userAvatars,
  getUserAvatars,
  getFakeSubs,
  getFakeStatuses
} from "../../data";
import { users } from "../../data/users";

import { PAuserLine } from "./PAuserLine";

const allCurrencies = [
  { label: "USD", id: "USD", value: "USD" },
  { label: "EUR", id: "EUR", value: "EUR" },
  { label: "RUB", id: "RUB", value: "RUB" }
];

let keyData = {};
let data = {};

export default function PAusersSubscribersPage({
  history,
  title,
  handleModal,
  index = 0
}) {
  const [ind, setInd] = useState();
  const [popEm, setPopEm] = useState(false);
  const [popDate, setPopDate] = useState(false);
  const [ren, setRen] = useState(true);
  const [renPop, setRenPop] = useState(false);
  const [ren2, setRen2] = useState(true);

  const [newDate, setNewDate] = useState();
  const [popStop, setPopStop] = useState(false);


  const  actions=[
    {
      label: "Change user email",
      // customIcon: <StatusDot status="enabled" />,
      customIcon: <Icon name="profile" />,
      iconAlign: "right",
      // onClick: () => handleEmail(index)
    },
    {
      label: "Change renewal date",
      // customIcon: <StatusDot status="enabled" />,
      customIcon: <Icon name="calendar" />,
      iconAlign: "right",
      // onClick: () => handleDate(index)
    },
    {
      label: "See relevant transactions (3)"
      // customIcon: <Icon name="calendar" />,
      // iconAlign: "right",
      // onClick: () => handleDate(index)
    },

    {
      color: "#fc2b55",
      label: "Cancel and refund",
      description: (
        <span style={{ color: "#fc2b55" }}>
          User will receive a refund for unused days
        </span>
      ),
      // customIcon: <StatusDot status="enabled" />,
      // customIcon: <Icon name="remove-circle" />,
      iconAlign: "right",
      // onClick: () => handleStop(index)
    }
  ]


  useEffect(() => {
    console.log("hist = ", history);
    let newAction = history.match.params.pageId || 0;

    if (typeof ind === "undefined") {
      setInd(newAction);
    }

    return () => {};
  }, [history]);

  if (typeof ind !== "undefined") {
    return (
      <div>
        {/* {popEm && (
         <PApopChangeEmail
            index={index}
            handleModal={() => setPopEm(false)}
         />
        )}


        {popDate && (
          <PApopChangeDate
            handleModal={() => setPopDate(false)}
          />
        )} */}



        <Head
          // appearance="separated"
          indentation="md"
          extra={
            <div style={{ display: "flex", justifyContent: "flex-end", paddingRight: 8 }}>
              <Dropdown
                autosize={true}
                align="right"
                // separated={true}
                options={[
                  {
                    label: "Stop renewing",
                    description: 'The subscription will be active until Oct 28, 2019',
                    // customIcon: <StatusDot status="enabled" />,
                    customIcon: <Icon name="block" />,
                    onClick: () => setPopStop(true),
                    iconAlign: "right"
                  },
                  {
                    label: "Cancel and refund",
                    description: "The user will receive a refund for unused days",
                      customIcon: <Icon name="remove-circle" />,
                    // onClick: () => handleStop(true),
                    iconAlign: "right"
                  },{
                    color: "#fc2b55",
                    label: "Cancel whithout refund",
                    customIcon: (<span style={{ color: "#eb002f" }}>
                      <Icon name="remove-circle" />
                    </span>),
                    iconAlign: "right",
                    // onClick: () => handleStop(index)
                  }
                ]}
              >
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    alignItems: "center",
                    flexGrow: 1,
                    height: "100%",
                    marginLeft: 16
                  }}
                >
                  <Icon name="more" size={28} />
                </div>
              </Dropdown>
            </div>
          }
        >
          {/* <Breadcrumbs
            items={[
              {
                label: <PAh2 title="Subscribers" indentation="xs" />,
                to: "/support/subscribers/"
              },
              {
                label: (
                  <PAh2 indentation="xs" title={users[ind]["email"]}></PAh2>
                ),
                to: "/support/subscribers/"
              }
            ]}
          /> */}

          <PAh2 indentation="xs" title="Subscriber details"></PAh2>


        </Head>




        <FormGroup>
          <div className="l_flex">
            <div className="login-user-list-container__user-info__image-container">
              <div
                className="login-user-list-container__user-info__image"
                // style={{backgroundImage:`url(${rw['picture']})`}}
                style={{backgroundImage:`url(${getUserAvatars(0.3)})`}}
              />
            </div>


            <div className="ui-table__column ui-table__column--indentation-sm">
              <div>
                {users[ind]["email"] ? users[ind]["email"] : 'No email'}
              </div>
              <div style={{color: '#747e8a'}}>
                {users[ind]["id"]}
              </div>
            </div>
          </div>
        </FormGroup>






            {/* TOP */}
            {/* <CardNew wave={false} hover={false}> */}
            <FormGroup indentation="lg">
              <PAuserInfo
                hover={false}
                email={users[ind]["email"]}
                purchase={[getFakeSubs()]}
                status={getFakeStatuses()}
                {...users[index]}
              />
            </FormGroup>
            {/* </CardNew> */}





        <FormGroup>



          {/* <PAContentBlock title="User" border={true}>
            <FormGroup indentation="lg">
              <FormGroup label="User email" indentation="sm">
                <div
                  style={{
                    display: "grid",
                    gridTemplateColumns: "1fr 44px",
                    gridColumnGap: 8
                  }}
                >
                  <Input
                    key="1"
                    offset="left"
                    icon="message"
                    disabled={true}
                    input={{
                      name: "1",
                      value: users[index]["email"]
                    }}
                  />
                  <Tooltip label="Change email per user requests">
                    {!popEm && <Button appearance="square" onClick={() => setPopEm(true)}>
                      <Icon name="edit" />
                    </Button>}
                    {!!popEm && <Button appearance="square" onClick={() => setPopEm(false)}>
                      <Icon name="close" />
                    </Button>}
                  </Tooltip>
                </div>
              </FormGroup>


              {popEm &&
              <FormGroup label="New user email" indentation="md">
                <div
                  style={{
                    display: "grid",
                    gridTemplateColumns: "280px 1fr",
                    gridColumnGap: 16
                  }}
                >
                  <Input
                    key="1"
                    offset="left"
                    icon="message"
                    // placeholder={users[index]["email"]}
                    input={{
                      name: "1",
                      value: users[index]["email"]
                    }}
                  />
                  <div className="">
                    <Button appearance="secondary" onClick={() => setPopEm(false)}>
                      Save
                    </Button>
                  </div>
                </div>
              </FormGroup>
              }

            </FormGroup>

          </PAContentBlock> */}

          {/* <PAContentBlock
            title="Renewal"
            border={true}
            className="ui-navigation--bordered"
          >

            <FormGroup label="" indentation="sm">
              <Switch
                name={`ref_${index}`}
                size="sm"
                // label='Allow refund with this reason'
                label="Auto-renewing"
                tooltip=""
                input={{
                  value: ren,
                  onChange: e => {
                    setRenPop(true);
                    setRen(!ren);
                  }
                }}
              />
            </FormGroup>

             {ren && <div>
               <FormGroup label="Renewal date" indentation="sm"><div
                style={{
                  display: "grid",
                  gridTemplateColumns: "1fr 44px",
                  gridColumnGap: 8
                }}
              >


                <Input
                  key="1"
                  offset="left"
                  icon="calendar"
                  placeholder={users[index]["email"]}
                  disabled={true}
                  input={{
                    name: "1",
                    value: "May 3, 2020"
                    // onFocus: handleFocus,
                    // onChange: e => {
                    //   let val = e.target.value;
                    //   setInp(val);
                    // }
                  }}
                />
                {!popDate && <Button appearance="square" onClick={() => setPopDate(true)}>
                  <Icon name="edit" />
                </Button>}
                {!!popDate && <Button appearance="square" onClick={() => setPopDate(false)}>
                  <Icon name="close" />
                </Button>}

              </div></FormGroup>

              {popDate && <FormGroup label="New renewal date">
              <div
                  style={{
                    display: "grid",
                    gridTemplateColumns: "210px 1fr",
                    gridColumnGap: 16
                  }}
                >
                 <DatePickerInput
                    name="single"
                    input={{
                      value: newDate,
                      onChange: (e) => {
                        setNewDate(e);
                      }
                    }}
                    size="sm"
                    pickTime={true}
                  />
                  {newDate && <div className="">
                    <Button appearance="secondary" size="sm" onClick={() => setPopDate(false)}>
                      Save
                    </Button>
                  </div>}
                </div>




                </FormGroup>
}

              </div>
            }







          </PAContentBlock> */}


          {/* <PAContentBlock title="Subsctiption status" border={true}>
            <FormGroup>
              <FormGroup label="Current status" indentation="md">
                <div
                  style={{
                    display: "grid",
                    gridTemplateColumns: "1fr 44px",
                    gridColumnGap: 8
                  }}
                >
                  <StatusDot status="enabled">Active</StatusDot>
                  <Tooltip label="Change email per user requests">
                    <Button appearance="square" onClick={() => setPopEm(true)}>
                      <Icon name="edit" />
                    </Button>
                  </Tooltip>
                </div>
              </FormGroup>

            </FormGroup>
          </PAContentBlock> */}





          <FormGroup>

          <FormGroup>
            <div style={{
              color: '#747e8a',
              fontSize: 11,
              fontWeight: 700,
              textTransform: 'uppercase',
            }}>Related Transactions</div>
          </FormGroup>


            <FormGroup>






              {['testing','enabled','enabled'].map((a, ind) => <CssLineHover key={`trans_${ind}`} style={{fontSize: 14}}>
              <CssTh cols="1fr 1fr 1fr 1fr 0.4fr">

                      <CssThTd>
                        <div className="transaction-registry-list__cell--hoverable transaction-registry-list__cell--inline">
                            <div className="xsui-status-dot xsui-status-dot--active">
                              <StatusDot status={a}></StatusDot>
                            </div>&nbsp;482748117
                        </div>
                        <div>
                          ID 22877
                        </div>
                      </CssThTd>

                      <CssThTd>
                          <div className="login-user-list-container__user-info__groups">
                            482748117
                          </div>
                          <div className="login-user-list-container__user-info__id">
                            ID 22877
                          </div>
                      </CssThTd>

                      <CssThTd>
                          <div className="login-user-list-container__user-info__groups">
                            Dec 17, 2019
                          </div>
                          <div className="login-user-list-container__user-info__id">
                            10:17 AM
                          </div>
                      </CssThTd>

                      <CssThTd>
                          <div className="login-user-list-container__user-info__groups">
                            EUR&nbsp;59.99
                          </div>
                          <div className="login-user-list-container__user-info__id">
                            Credit/Debit Cards (EUR)
                          </div>
                      </CssThTd>



                   <div>
                        <Dropdown
                          autosize={true}
                          align="right"
                          // separated={true}
                          options={[
                            {
                              label: 'Transaction details',
                              customIcon: <Icon name="list-view" />,
                              value: 0,
                            },
                            {
                              label: 'Refund to balance',
                              value: 1,
                              customIcon: <Icon name="redo" />,
                              iconAlign: "right",
                            },
                            {
                              label: 'Refund',
                              value: 2,
                              customIcon: <Icon name="redo" />,
                              iconAlign: "right",
                            },
                            {
                              label: 'Request to refund',
                              value: 3,
                              customIcon: <Icon name="list-view" />,
                              iconAlign: "right",
                            },
                          ]}
                        >
                          <Icon name="more" />
                        </Dropdown>
                  </div>

                </CssTh>
    </CssLineHover>)}



            </FormGroup>
          </FormGroup>
        </FormGroup>




        {popStop && (
          <PApopStop
            handleModal={() => setPopStop(false)}
          />
        )}

      </div>
    );
  } else {
    return null;
  }
}







export function PAusersSubscribersPop ({
  handleModal = ()=>void(0),
  history
}) {
  return (
    <PAmodal handleModal={()=> history.history.push('/support/subscribers/')} indentation="xs"
    // appearance="sidebar"
    appearance="md"
    >
      <FormGroup>
        <PAusersSubscribersPage
          history={history}
        />
      </FormGroup>
    </PAmodal>
  )
}




export function PApopStop({
  handleModal = ()=>void(0)
}) {
  return (
    <PAmodal handleModal={handleModal} indentation="xs">
      <FormGroup>
        <PAalert handleModal={handleModal}/>
      </FormGroup>
    </PAmodal>
  )
}


export function PApopChangeEmail({
  index = 0,
  handleModal = ()=>void(0)
}) {
  return (
    // <PAmodal header="Change user email" handleModal={handleModal}>

      <FormGroup>
        <FormGroup label="Old user email" indentation="sm">
          <Input
            size="sm"
            disabled={true}
            input={{
              value: users[index]["email"]
            }}
          />
        </FormGroup>
        <FormGroup label="New user email">
          <Input
            size="sm"
            placeholder="newmail@mail.com"
            input={{
              value: null
            }}
          />
        </FormGroup>
        {/* <FormFooter ignoreCentered={true}> */}

        <FormGroup>
          <Button appearance="secondary" size="sm" disabled={true}>
            Save new user email
          </Button>
        </FormGroup>


        {/* </FormFooter> */}
      </FormGroup>

  // </PAmodal>
  )
}



export function PApopChangeDate({
  handleModal = ()=>void(0)
}) {
  return (
      // <PAmodal
      //       header="Change renewal date"
      //       handleModal={handleModal}
      //     >
            <FormGroup>
              <FormGroup>
                <FormGroup label="Next charge date" indentation="sm">
                  <Input
                    disabled={true}
                    size="sm"
                    input={{
                      value: "May 3, 2020"
                    }}
                  />
                </FormGroup>
                <FormGroup label="New charge date" indentation="md">
{/*
                <div style={{ display: "flex" }}>



                      <Select
                        // style={{
                        //   flexGrow: 1,
                        //   flexBasis: "33%",
                        //   width: 64
                        // }}
                        // disabled={this.disabled}
                        name=""
                        options={[
                          {
                            label: '2019',
                            value: 2019
                          },
                          {
                            label: '2020',
                            value: 2020
                          },
                          {
                            label: '2021',
                            value: 2021
                          },
                        ]}
                        searchable={false}
                        autosize={false}
                        dock={"right"}
                        // size={"sm"}
                        input={{
                          // onChange: setDefCurr,
                          value: 123
                        }}
                      />


<CssSelectDocked>
                      <Select
                        // style={{
                        //   flexGrow: 1,
                        //   flexBasis: "33%",
                        //   width: 64
                        // }}
                        // disabled={this.disabled}
                        name=""
                        options={[
                          {
                            label: 'January',
                            value: 'jan'
                          },
                          {
                            label: 'February',
                            value: 'feb'
                          },
                          {
                            label: 'March',
                            value: 'mar'
                          },
                          {
                            label: 'April',
                            value: 'apr'
                          },
                        ]}
                        searchable={false}
                        autosize={false}
                        // dock={"left-right"}
                        // size={"sm"}
                        input={{
                          // onChange: setDefCurr,
                          value: 'jan'
                        }}
                      />
</CssSelectDocked>



                        <Input
                          dock={"left"}
                          // style={{
                          //   flexGrow: 1,
                          //   flexBasis: "33%",
                          //   width: 64
                          // }}
                          // size="sm"
                          input={{
                            value: 14
                          }}
                        />


                  </div> */}

                  <DatePickerInput
                    name="single"
                    size="sm"
                    input={{
                      // value: this.state.single,
                      onChange: () => {
                        void 0;
                      }
                    }}
                    pickTime={false}
                  />



                </FormGroup>
                <FormGroup>
                  <Button appearance="secondary" disabled={true} size="sm">
                    Save changes
                  </Button>
                </FormGroup>
              </FormGroup>
            </FormGroup>
          // </PAmodal>

  )
}


function PAalert({
  handleModal = ()=>void(0)
}) {
  let [pubState, setPubState] = useState(false);

  const invertState = () => {
    setPubState(!pubState);
  };

  return (

          <form
            onSubmit={e => {
              e.preventDefault();
              console.log("regular form submit"); // eslint-disable-line
            }}
          >
            {/* <Head>Launcher publishing</Head> */}
            <div
              className="modal-alert"
              style={{
                display: "flex",
                alignItems: "stretch",
                flexDirection: "column",
                textAlign: "center"
              }}
            >
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  width: "100%"
                }}
              >
                <img
                  className="modal-alert__icon"
                  src="https://uikit.xsolla.com/static/981e91bf767ccf82cd8f57caf45483c7.svg"
                />
                <div className="modal-alert__title">Stop renewal?</div>

                <div className="modal-alert__description">

                </div>

                <div className="modal-alert__confirmation">
                  <div className="xsui-form-group xsui-form-group--primary xsui-form-group--direction-column xsui-form-group--indentation-md xsui-form-group--centered">
                    <div className="xsui-form-group__entry">
                      <div className="xsui-checkbox xsui-checkbox--primary">
                        <div className="xsui-checkbox__wrapper">
                          <Checkbox
                            name="checkbox"
                            label="Yes, I understand effect"
                            input={{
                              value: pubState,
                              onChange: invertState
                            }}
                            // disabled={true}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <FormFooter sticky={true}>
                <Button
                  disabled={pubState ? false : true}
                  type="submit"
                  onClick={() => handleModal()}
                >
                  Stop
                </Button>
              </FormFooter>
            </div>
          </form>

  );
}










export function PAuserInfo({
  hover = true,
  handleClick =()=>void(0),
  index,
  purchase = [],
  status = '',
  type,
  id = "0299233e-04b9-450c-a2da-3ec3cd5776f8",
  nickname = null,
  name = null,
  picture = null,
  birthday = null,
  first_name = null,
  last_name = null,
  gender = null,
  email = null,
  phone = null,
  groups = [
    {
      id: 24,
      name: "default",
      is_default: true,
      is_deletable: false
    }
  ],
  registered = "2019-09-30T19:02:56+0300",
  external_id = null,
  last_login = "2019-09-30T21:53:34+0300",
  ban = null,
  country = null,
  actions
}) {
  return (

      <div>

        {/* <CssClick onClick={() => handleClick(index)}/> */}


<FormGroup indentation="sm">
            <CssInfoLi>

              <CssLeft>Status</CssLeft>

              <Dropdown
                    // align="left"
                    autosize={true} size="md"
                    // separated={true}
                    options={[
                      {
                        label: "Stop renewing",
                        description: "The subscription will be active until Oct 28, 2019",
                        customIcon: <Icon name="block" />,
                        // onClick: () => handleStop(true),
                        iconAlign: "right"
                      },
                      {
                        label: "Cancel and refund",
                        description: "The user will receive a refund for unused days",
                          customIcon: <Icon name="remove-circle" />,
                        // onClick: () => handleStop(true),
                        iconAlign: "right"
                      },{
                        color: "#fc2b55",
                        label: "Cancel whithout refund",
                        // description: (
                        //   <span style={{ color: "#fc2b55" }}>
                        //     User will receive a refund for unused days
                        //   </span>
                        // ),
                        customIcon: (<span style={{ color: "#eb002f" }}>
                          <Icon name="remove-circle" />
                        </span>),
                        iconAlign: "right",
                        // onClick: () => handleStop(index)
                      }
                    ]}>

                    <Pill appearance={status["appearance"]}>
                      {status["title"]}
                    </Pill>

                  </Dropdown>

            </CssInfoLi>
</FormGroup>

          <FormGroup indentation="sm">
            <CssInfoLi>

              <CssLeft>Internal ID</CssLeft>

              <div className="">
                  1209310238091
              </div>

            </CssInfoLi>
          </FormGroup>

        <FormGroup indentation="sm">
          {purchase.map(onePurch => (
          <CssInfoLi>

            <CssLeft>Subscription Plan</CssLeft>

            <div className="">

              <strong>
                {onePurch['label']}
              </strong>
            </div>
          </CssInfoLi>))}
        </FormGroup>


        <FormGroup indentation="sm">
          {purchase.map(onePurch => (
          <CssInfoLi>

            <CssLeft>Price</CssLeft>

            <div className="">
              {/* <div className="login-user-list-container__user-info__id"> */}
                {onePurch['price']}
              {/* </div> */}
            </div>
          </CssInfoLi>))}
        </FormGroup>



      <div style={{borderBottom: '1px solid #ccc', height: 1, margin: '16px 0'}} />


      <FormGroup indentation="sm">
        <CssInfoLi>


          <CssLeft>Email</CssLeft>


          <Dropdown size="lg" type="inform"
                // align="left"
                autosize={true} separated={false} content={{
                  title: "User email",
                  description: <PApopChangeEmail />,
          }}>
              <CssThTd onClick={true} style={{marginRight: 36}}>
                <div className="login-user-list-container__user-info__email">
                  {/* <div className="login-user-list-container__user-info__groups"> */}
                  {email ? email : 'No email'}
                  {/* </div> */}
                </div>
              </CssThTd>
          </Dropdown>

        </CssInfoLi>
      </FormGroup>


      <FormGroup indentation="sm">
        <CssInfoLi>

          <CssLeft>User ID</CssLeft>

          {/* <div className="login-user-list-container__user-info__email"> */}
            {/* <div className="login-user-list-container__user-info__id"> */}
              {id}
            {/* </div> */}
          {/* </div> */}
        </CssInfoLi>
      </FormGroup>

      <FormGroup indentation="sm">
        <CssInfoLi>

          <CssLeft>User Profile</CssLeft>

          {/* <div className="login-user-list-container__user-info__email"> */}
            {/* <div className="login-user-list-container__user-info__id"> */}
              <a href="https://livedemo.xsolla.com/twitch_ps3/" target="_blank">
                <Button appearance="flatten" size="sm">
                  Show user page <Icon name="new-tab"/>
                </Button>
              </a>
            {/* </div> */}
          {/* </div> */}
        </CssInfoLi>
      </FormGroup>


      <div style={{borderBottom: '1px solid #ccc', height: 1, margin: '16px 0'}} />


      <FormGroup indentation="sm">
        <CssInfoLi>

          <CssLeft>Start date</CssLeft>

          {/* <div className="login-user-list-container__user-info__groups"> */}
            May 26, 2018  10:17 AM
          {/* </div> */}
        </CssInfoLi>
      </FormGroup>


      <FormGroup indentation="sm">
        <CssInfoLi>

          <CssLeft>End date</CssLeft>

          {/* <div className="login-user-list-container__user-info__groups"> */}
            May 26, 2024  10:17 AM
          {/* </div> */}
        </CssInfoLi>
      </FormGroup>


      <FormGroup indentation="sm">
        <CssInfoLi>

          <CssLeft>Last charge date</CssLeft>

          {/* <div className="login-user-list-container__user-info__groups"> */}
            Oct 17, 2019  8:56 AM
          {/* </div> */}
        </CssInfoLi>
      </FormGroup>

      <FormGroup indentation="sm">
        {purchase.map(onePurch => (
          <CssInfoLi>

            <CssLeft>Last charge</CssLeft>

              {/* <div className="login-user-list-container__user-info__id"> */}
              <strong>
                {onePurch['price']}
              </strong>
              {/* </div> */}
          </CssInfoLi>))}
        </FormGroup>




        {/* <FormGroup indentation="sm">
        {purchase.map(onePurch => (
          <CssInfoLi>

            <CssLeft>Internal comment</CssLeft>

              <div className="l_flex">
                <span style={{fontSize: '1em', lineHeight: '1.2em'}}>
                  This user constatntly requests refunds
                </span>
                <Button appearance='flatten'><Icon name="edit"/></Button>
              </div>
          </CssInfoLi>))}
        </FormGroup> */}




      </div>

  );
}



















const CssSelectDocked = styled.div`
& .xsui-input--size-md {
  border-radius: 0;
  margin-right: -1px;
}
`;

const CssPopGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  grid-column-gap: 24px;
`;

const CssSelectItems = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 5px;
  margin: 0px 0 0 0px;
`;


const CssInfoLi = styled.div`
  display: grid;
  grid-template-columns: 1fr 1.6fr;
  grid-column-gap: 24px;
`;

const CssLeft = styled.div`
  color: #747e8a;
  font-size: 14px;
  letter-spacing: -.2px;
  line-height: 1.54;
`;
